var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: _vm.tituloModal } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstado,
                                  readonly: _vm.modoVer
                                },
                                on: { change: _vm.cambioEstadoSwitch },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("CampoUnico", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|max:80|" + _vm.uniqueFieldRule,
                                    expression:
                                      "`required|max:80|${uniqueFieldRule}`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  counter: "80",
                                  disabled: _vm.modoVer,
                                  validate: _vm.validarNombre,
                                  message:
                                    "Ya existe una Alerta con este nombre"
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tipo.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tipo.id
                                  ),
                                  "data-vv-name": _vm.formFields.tipo.id,
                                  items: _vm.lstAlertasBase,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  disabled: _vm.modoVer || _vm.modoEditar
                                },
                                on: { change: _vm.handlerChangeTipo },
                                model: {
                                  value: _vm.formFields.tipo.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.tipo, "value", $$v)
                                  },
                                  expression: "formFields.tipo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-autocomplete", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "styled-select",
                                attrs: {
                                  label: _vm.formFields.color.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.color.id
                                  ),
                                  "data-vv-name": _vm.formFields.color.id,
                                  "item-value": "title",
                                  "item-text": "title",
                                  "no-data-text": "Sin resultados",
                                  items: _vm.colores,
                                  disabled: _vm.modoVer
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(data) {
                                      return [
                                        _c("v-avatar", {
                                          attrs: {
                                            color: data.item.icon,
                                            size: "20"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                   " +
                                            _vm._s(data.item.title) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "item",
                                    fn: function(data) {
                                      return [
                                        typeof data.item !== "object"
                                          ? [
                                              _c("v-list-tile-content", {
                                                domProps: {
                                                  textContent: _vm._s(data.item)
                                                }
                                              })
                                            ]
                                          : [
                                              _c("v-list-tile-avatar", {
                                                attrs: { color: data.item.icon }
                                              }),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        data.item.title
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.formFields.color.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.color, "value", $$v)
                                  },
                                  expression: "formFields.color.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.muestraAlertaGenerica,
                              expression: "muestraAlertaGenerica"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaGenerica &&
                                          (!_vm.formFields.temporalidad.value ||
                                            _vm.formFields.temporalidad.value ==
                                              0)
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 2,
                                        min_value:
                                          _vm.muestraAlertaGenerica &&
                                          _vm.formFields.temporalidad.value < 1
                                            ? 1
                                            : 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaGenerica &&\n                      (!formFields.temporalidad.value ||\n                        formFields.temporalidad.value == 0)\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 2,\n                    min_value:\n                      muestraAlertaGenerica &&\n                      formFields.temporalidad.value < 1\n                        ? 1\n                        : 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.eventos.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.eventos.id
                                  ),
                                  "data-vv-name": _vm.formFields.eventos.id,
                                  disabled: _vm.modoVer,
                                  counter: "2"
                                },
                                model: {
                                  value: _vm.formFields.eventos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.eventos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.eventos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaGenerica &&
                                          (!_vm.formFields.eventos.value ||
                                            _vm.formFields.eventos.value == 0)
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 3,
                                        min_value:
                                          _vm.muestraAlertaGenerica &&
                                          _vm.formFields.eventos.value < 1
                                            ? 1
                                            : 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaGenerica &&\n                      (!formFields.eventos.value ||\n                        formFields.eventos.value == 0)\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 3,\n                    min_value:\n                      muestraAlertaGenerica && formFields.eventos.value < 1\n                        ? 1\n                        : 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.temporalidad.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.temporalidad.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.temporalidad.id,
                                  disabled: _vm.modoVer,
                                  counter: "3"
                                },
                                model: {
                                  value: _vm.formFields.temporalidad.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.temporalidad,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.temporalidad.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._l(_vm.lstCampos, function(campo) {
                            return _c(
                              "v-flex",
                              {
                                key: campo.id,
                                attrs: { xs12: "", sm6: "", md6: "" }
                              },
                              [
                                campo.tipoCampo != 4
                                  ? _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            rules: {
                                              required: campo.requerido
                                            }
                                          },
                                          expression:
                                            "{\n                  rules: {\n                    required: campo.requerido,\n                  },\n                }"
                                        }
                                      ],
                                      ref: campo.id,
                                      refInFor: true,
                                      attrs: {
                                        label: campo.descripcionCampo,
                                        "error-messages": _vm.errors.collect(
                                          "" + campo.id
                                        ),
                                        "data-vv-name": campo.id,
                                        disabled: _vm.modoVer
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleCamposChange(
                                            campo.id,
                                            $event
                                          )
                                        },
                                        keyup: function($event) {
                                          return _vm.handleCamposKeyUp(
                                            campo.id,
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: campo.valor,
                                        callback: function($$v) {
                                          _vm.$set(campo, "valor", $$v)
                                        },
                                        expression: "campo.valor"
                                      }
                                    })
                                  : _vm._e(),
                                campo.tipoCampo == 4
                                  ? _c("v-switch", {
                                      attrs: {
                                        label: campo.descripcionCampo,
                                        color: "success",
                                        "persistent-hint": "",
                                        disabled: _vm.modoVer
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleCamposChange(
                                            campo.id,
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: campo.valor,
                                        callback: function($$v) {
                                          _vm.$set(campo, "valor", $$v)
                                        },
                                        expression: "campo.valor"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          })
                        ],
                        2
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.muestraAlertaZona,
                              expression: "muestraAlertaZona"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required: _vm.muestraAlertaZona
                                          ? true
                                          : false,
                                        validaFecha: _vm.muestraAlertaZona
                                          ? true
                                          : false
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required: muestraAlertaZona ? true : false,\n                    validaFecha: muestraAlertaZona ? true : false,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.desde.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.desde.id
                                  ),
                                  id: _vm.formFields.desde.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.desde.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.desde, "value", $$v)
                                  },
                                  expression: "formFields.desde.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required: _vm.muestraAlertaZona
                                          ? true
                                          : false,
                                        validaFecha: _vm.muestraAlertaZona
                                          ? true
                                          : false
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required: muestraAlertaZona ? true : false,\n                    validaFecha: muestraAlertaZona ? true : false,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.hasta.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.hasta.id
                                  ),
                                  id: _vm.formFields.hasta.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.hasta.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.hasta, "value", $$v)
                                  },
                                  expression: "formFields.hasta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.formFields.parametrosGenerales.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  readonly: _vm.modoVer
                                },
                                on: {
                                  change: _vm.handleParametrosGeneralesChange
                                },
                                model: {
                                  value:
                                    _vm.formFields.parametrosGenerales.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.parametrosGenerales,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.parametrosGenerales.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaZona &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        min_value: 1,
                                        numeric: true,
                                        max: 3,
                                        max_value: 240,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaZona && !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    min_value: 1,\n                    numeric: true,\n                    max: 3,\n                    max_value: 240,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.velocidad.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.velocidad.id
                                  ),
                                  "data-vv-name": _vm.formFields.velocidad.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "3"
                                },
                                on: {
                                  change: _vm.handleVelocidadChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.velocidad.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.velocidad,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.velocidad.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaZona &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 2,
                                        max_value: 99,
                                        min_value: 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaZona && !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 2,\n                    max_value: 99,\n                    min_value: 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tolerancia.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tolerancia.id
                                  ),
                                  "data-vv-name": _vm.formFields.tolerancia.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "2"
                                },
                                on: {
                                  change: _vm.handleToleranciaChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.tolerancia.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tolerancia,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tolerancia.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaZona &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        max: 3,
                                        max_value: 9.9,
                                        min_value: 0.1,
                                        decimal: 1
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaZona && !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    max: 3,\n                    max_value: 9.9,\n                    min_value: 0.1,\n                    decimal: 1,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.hdopdesde.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.hdopdesde.id
                                  ),
                                  "data-vv-name": _vm.formFields.hdopdesde.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "3"
                                },
                                on: {
                                  change: _vm.handlehDopdesdeChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumberDecimal(
                                      $event
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.formFields.hdopdesde.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.hdopdesde,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.hdopdesde.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaZona &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        max: 3,
                                        max_value: 9.9,
                                        min_value:
                                          _vm.formFields.hdopdesde.value,
                                        decimal: 1
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaZona && !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    max: 3,\n                    max_value: 9.9,\n                    min_value: formFields.hdopdesde.value,\n                    decimal: 1,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.hdophasta.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.hdophasta.id
                                  ),
                                  "data-vv-name": _vm.formFields.hdophasta.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "3"
                                },
                                on: {
                                  change: _vm.handlehDophastaChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumberDecimal(
                                      $event
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.formFields.hdophasta.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.hdophasta,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.hdophasta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaZona &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 99,
                                        max_value: 99,
                                        min_value: 3,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaZona && !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 99,\n                    max_value: 99,\n                    min_value: 3,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nsatelites.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nsatelites.id
                                  ),
                                  "data-vv-name": _vm.formFields.nsatelites.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "2"
                                },
                                on: {
                                  change: _vm.handlenSatelitesChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.nsatelites.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nsatelites,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nsatelites.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaZona &&
                                          (!_vm.formFields.temporalidad.value ||
                                            _vm.formFields.temporalidad.value ==
                                              0) &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 2,
                                        min_value:
                                          _vm.muestraAlertaZona &&
                                          _vm.formFields.temporalidad.value < 1
                                            ? 1
                                            : 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaZona &&\n                      (!formFields.temporalidad.value ||\n                        formFields.temporalidad.value == 0) &&\n                      !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 2,\n                    min_value:\n                      muestraAlertaZona && formFields.temporalidad.value < 1\n                        ? 1\n                        : 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.eventos.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.eventos.id
                                  ),
                                  "data-vv-name": _vm.formFields.eventos.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "2"
                                },
                                on: {
                                  change: _vm.handleEventosChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.eventos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.eventos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.eventos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaZona &&
                                          (!_vm.formFields.eventos.value ||
                                            _vm.formFields.eventos.value ==
                                              0) &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 3,
                                        min_value:
                                          _vm.muestraAlertaZona &&
                                          _vm.formFields.eventos.value < 1
                                            ? 1
                                            : 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaZona &&\n                      (!formFields.eventos.value ||\n                        formFields.eventos.value == 0) &&\n                      !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 3,\n                    min_value:\n                      muestraAlertaZona && formFields.eventos.value < 1\n                        ? 1\n                        : 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.temporalidad.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.temporalidad.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.temporalidad.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "3"
                                },
                                on: {
                                  change: _vm.handleTemporalidadChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.temporalidad.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.temporalidad,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.temporalidad.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: _vm.formFields.tipoZona.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tipoZona.id
                                  ),
                                  "data-vv-name": _vm.formFields.tipoZona.id,
                                  items: _vm.lstTipoZonas,
                                  "item-text": "nombre",
                                  "item-value": "id"
                                },
                                on: { change: _vm.handleTipoZonaChange },
                                model: {
                                  value: _vm.formFields.tipoZona.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tipoZona,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tipoZona.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("Buscador", {
                                attrs: {
                                  filter:
                                    _vm.gridApiZonas &&
                                    _vm.gridApiZonas.setQuickFilter.bind(
                                      _vm.gridApiZonas
                                    )
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-container",
                            {
                              attrs: {
                                "grid-list-md": "",
                                "text-xs-center": ""
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md12: "" } },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _vm.modoVer
                                            ? _c("MantenedorGridVerDetalle", {
                                                attrs: {
                                                  "grid-options":
                                                    _vm.gridOptionsZonas,
                                                  "row-data":
                                                    _vm.lstZonasVerDetalle
                                                }
                                              })
                                            : _c("AsociacionGrid", {
                                                attrs: {
                                                  "grid-options":
                                                    _vm.gridOptionsZonas,
                                                  esEditar: !_vm.alertaSeleccionada
                                                    ? false
                                                    : true,
                                                  headerCheckbox: false
                                                }
                                              })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.muestraAlertaRuta,
                              expression: "muestraAlertaRuta"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required: _vm.muestraAlertaRuta
                                          ? true
                                          : false,
                                        validaFecha: _vm.muestraAlertaRuta
                                          ? true
                                          : false
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required: muestraAlertaRuta ? true : false,\n                    validaFecha: muestraAlertaRuta ? true : false,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.desde.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.desde.id
                                  ),
                                  id: _vm.formFields.desde.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.desde.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.desde, "value", $$v)
                                  },
                                  expression: "formFields.desde.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required: _vm.muestraAlertaRuta
                                          ? true
                                          : false,
                                        validaFecha: _vm.muestraAlertaRuta
                                          ? true
                                          : false
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required: muestraAlertaRuta ? true : false,\n                    validaFecha: muestraAlertaRuta ? true : false,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.hasta.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.hasta.id
                                  ),
                                  id: _vm.formFields.hasta.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.hasta.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.hasta, "value", $$v)
                                  },
                                  expression: "formFields.hasta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.formFields.parametrosGenerales.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  readonly: _vm.modoVer
                                },
                                on: {
                                  change: _vm.handleParametrosGeneralesChange
                                },
                                model: {
                                  value:
                                    _vm.formFields.parametrosGenerales.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.parametrosGenerales,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.parametrosGenerales.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaRuta &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        min_value: 1,
                                        integer: true,
                                        max_value: 240,
                                        max: 3
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaRuta && !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    min_value: 1,\n                    integer: true,\n                    max_value: 240,\n                    max: 3,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.velocidad.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.velocidad.id
                                  ),
                                  "data-vv-name": _vm.formFields.velocidad.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "3"
                                },
                                on: {
                                  change: _vm.handleVelocidadChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.velocidad.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.velocidad,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.velocidad.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaRuta &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 2,
                                        max_value: 99,
                                        min_value: 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaRuta && !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 2,\n                    max_value: 99,\n                    min_value: 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tolerancia.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tolerancia.id
                                  ),
                                  "data-vv-name": _vm.formFields.tolerancia.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "2"
                                },
                                on: {
                                  change: _vm.handleToleranciaChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.tolerancia.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tolerancia,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tolerancia.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaRuta &&
                                          (!_vm.formFields.temporalidad.value ||
                                            _vm.formFields.temporalidad.value ==
                                              0) &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 2,
                                        min_value:
                                          _vm.muestraAlertaRuta &&
                                          _vm.formFields.temporalidad.value < 1
                                            ? 1
                                            : 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaRuta &&\n                      (!formFields.temporalidad.value ||\n                        formFields.temporalidad.value == 0) &&\n                      !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 2,\n                    min_value:\n                      muestraAlertaRuta && formFields.temporalidad.value < 1\n                        ? 1\n                        : 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.eventos.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.eventos.id
                                  ),
                                  "data-vv-name": _vm.formFields.eventos.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "3"
                                },
                                on: {
                                  change: _vm.handleEventosChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.eventos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.eventos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.eventos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaRuta &&
                                          (!_vm.formFields.eventos.value ||
                                            _vm.formFields.eventos.value ==
                                              0) &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 3,
                                        min_value:
                                          _vm.muestraAlertaRuta &&
                                          _vm.formFields.eventos.value < 1
                                            ? 1
                                            : 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaRuta &&\n                      (!formFields.eventos.value ||\n                        formFields.eventos.value == 0) &&\n                      !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 3,\n                    min_value:\n                      muestraAlertaRuta && formFields.eventos.value < 1\n                        ? 1\n                        : 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.temporalidad.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.temporalidad.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.temporalidad.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "3"
                                },
                                on: {
                                  change: _vm.handleTemporalidadChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.temporalidad.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.temporalidad,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.temporalidad.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: _vm.formFields.tipoZona.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tipoZona.id
                                  ),
                                  "data-vv-name": _vm.formFields.tipoZona.id,
                                  items: _vm.lstTipoZonas,
                                  "item-text": "nombre",
                                  "item-value": "id"
                                },
                                on: { change: _vm.handleTipoZonaChange },
                                model: {
                                  value: _vm.formFields.tipoZona.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tipoZona,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tipoZona.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("Buscador", {
                                attrs: {
                                  filter:
                                    _vm.gridApiZonasRutas &&
                                    _vm.gridApiZonasRutas.setQuickFilter.bind(
                                      _vm.gridApiZonasRutas
                                    )
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-container",
                            {
                              attrs: {
                                "grid-list-md": "",
                                "text-xs-center": ""
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md12: "" } },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _vm.modoVer
                                            ? _c("MantenedorGridVerDetalle", {
                                                attrs: {
                                                  "grid-options":
                                                    _vm.gridOptionsZonasRutas,
                                                  "row-data":
                                                    _vm.lstZonasVerDetalle
                                                }
                                              })
                                            : _c("AsociacionGrid", {
                                                attrs: {
                                                  "grid-options":
                                                    _vm.gridOptionsZonasRutas,
                                                  esEditar: !_vm.alertaSeleccionada
                                                    ? false
                                                    : true,
                                                  headerCheckbox: false
                                                }
                                              })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.muestraAlertaUsoNoAutorizado,
                              expression: "muestraAlertaUsoNoAutorizado"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.zona.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.zona.id
                                  ),
                                  "data-vv-name": _vm.formFields.zona.id,
                                  items: _vm.lstZonas,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  disabled: _vm.modoVer,
                                  clearable: "",
                                  multiple: "",
                                  chips: "",
                                  "deletable-chips": "",
                                  dense: ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend-item",
                                    fn: function() {
                                      return [
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                label: "Seleccionar todos"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.selectAllFlota()
                                                }
                                              },
                                              model: {
                                                value: _vm.checkAllZonas,
                                                callback: function($$v) {
                                                  _vm.checkAllZonas = $$v
                                                },
                                                expression: "checkAllZonas"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("v-divider")
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var item = ref.item
                                      var index = ref.index
                                      return [
                                        index === 0
                                          ? _c("v-chip", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.textoComprimido(
                                                      item.nombre
                                                    )
                                                  )
                                                )
                                              ])
                                            ])
                                          : _vm._e(),
                                        index === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "grey--text text-caption",
                                                staticStyle: {
                                                  "font-size": "0.75em"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    (+" +
                                                    _vm._s(
                                                      _vm.formFields.zona.value
                                                        .length - 1
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.formFields.zona.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.zona, "value", $$v)
                                  },
                                  expression: "formFields.zona.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required: _vm.muestraAlertaUsoNoAutorizado
                                          ? true
                                          : false,
                                        numeric: true,
                                        max: 2,
                                        max_value: 99,
                                        min_value: 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required: muestraAlertaUsoNoAutorizado ? true : false,\n                    numeric: true,\n                    max: 2,\n                    max_value: 99,\n                    min_value: 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tolerancia.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tolerancia.id
                                  ),
                                  "data-vv-name": _vm.formFields.tolerancia.id,
                                  disabled: _vm.modoVer,
                                  counter: "2"
                                },
                                model: {
                                  value: _vm.formFields.tolerancia.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tolerancia,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tolerancia.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaUsoNoAutorizado &&
                                          (!_vm.formFields.temporalidad.value ||
                                            _vm.formFields.temporalidad.value ==
                                              0)
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 4,
                                        min_value:
                                          _vm.muestraAlertaUsoNoAutorizado &&
                                          _vm.formFields.temporalidad.value < 1
                                            ? 1
                                            : 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaUsoNoAutorizado &&\n                      (!formFields.temporalidad.value ||\n                        formFields.temporalidad.value == 0)\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 4,\n                    min_value:\n                      muestraAlertaUsoNoAutorizado &&\n                      formFields.temporalidad.value < 1\n                        ? 1\n                        : 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.eventos.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.eventos.id
                                  ),
                                  "data-vv-name": _vm.formFields.eventos.id,
                                  disabled: _vm.modoVer,
                                  counter: "4"
                                },
                                model: {
                                  value: _vm.formFields.eventos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.eventos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.eventos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaUsoNoAutorizado &&
                                          (!_vm.formFields.eventos.value ||
                                            _vm.formFields.eventos.value == 0)
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 3,
                                        min_value:
                                          _vm.muestraAlertaUsoNoAutorizado &&
                                          _vm.formFields.eventos.value < 1
                                            ? 1
                                            : 0,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaUsoNoAutorizado &&\n                      (!formFields.eventos.value ||\n                        formFields.eventos.value == 0)\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 3,\n                    min_value:\n                      muestraAlertaUsoNoAutorizado &&\n                      formFields.eventos.value < 1\n                        ? 1\n                        : 0,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.temporalidad.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.temporalidad.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.temporalidad.id,
                                  disabled: _vm.modoVer,
                                  counter: "3"
                                },
                                model: {
                                  value: _vm.formFields.temporalidad.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.temporalidad,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.temporalidad.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c(
                                "table",
                                {
                                  attrs: {
                                    id: "tDiasHoras",
                                    "aria-hidden": "true"
                                  }
                                },
                                [
                                  _c("thead", [
                                    _c(
                                      "tr",
                                      [
                                        _c("th", { attrs: { id: "thHora" } }),
                                        _vm._l(_vm.dias, function(dia) {
                                          return _c(
                                            "th",
                                            {
                                              key: dia.id,
                                              attrs: { id: dia.id }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(dia.value) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.horas, function(hora) {
                                      return _c(
                                        "tr",
                                        { key: hora },
                                        [
                                          _c("th", { attrs: { id: hora } }, [
                                            _vm._v(_vm._s(hora))
                                          ]),
                                          _vm._l(_vm.dias, function(dia) {
                                            return _c("td", {
                                              key: dia.value,
                                              attrs: {
                                                id: dia.id + "_" + hora,
                                                disabled: _vm.modoVer
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleClickDiaHora(
                                                    dia.id,
                                                    hora,
                                                    _vm.modoVer
                                                  )
                                                }
                                              }
                                            })
                                          })
                                        ],
                                        2
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.muestraAlertaDetencionNoAutorizada,
                              expression: "muestraAlertaDetencionNoAutorizada"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "", lg6: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "", disabled: _vm.modoVer },
                                  on: { change: _vm.handlerChangeIgnicion },
                                  model: {
                                    value:
                                      _vm.formFields.vehiculoIgnicion.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.vehiculoIgnicion,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formFields.vehiculoIgnicion.value"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Vehículo sin ignición",
                                      value: "sinIgnicion"
                                    }
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Vehículo con ignición",
                                      value: "conIgnicion"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "numeric",
                                    expression: "'numeric'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.velocidadIgnicion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.velocidadIgnicion.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.velocidadIgnicion.id,
                                  disabled:
                                    _vm.deshabilitaDetencionVelocidad ||
                                    _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.velocidadIgnicion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.velocidadIgnicion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.velocidadIgnicion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.formFields.parametrosGenerales.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  readonly: _vm.modoVer
                                },
                                on: {
                                  change: _vm.handleParametrosGeneralesChange
                                },
                                model: {
                                  value:
                                    _vm.formFields.parametrosGenerales.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.parametrosGenerales,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.parametrosGenerales.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.esAcumulable && _vm.showEventos
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          rules: {
                                            required:
                                              _vm.muestraAlertaDetencionNoAutorizada &&
                                              !_vm.deshabilitaParametrosGenerales
                                                ? true
                                                : false,
                                            min_value: 1,
                                            max: 2,
                                            integer: true
                                          }
                                        },
                                        expression:
                                          "{\n                  rules: {\n                    required:\n                      muestraAlertaDetencionNoAutorizada &&\n                      !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    min_value: 1,\n                    max: 2,\n                    integer: true,\n                  },\n                }"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.formFields.eventos.label,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.eventos.id
                                      ),
                                      "data-vv-name": _vm.formFields.eventos.id,
                                      disabled:
                                        _vm.modoVer ||
                                        _vm.deshabilitaParametrosGenerales,
                                      counter: "2"
                                    },
                                    on: {
                                      change: _vm.handleEventosChange,
                                      keypress: function($event) {
                                        return _vm.handleFilterInputNumber(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.eventosDetencion.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.eventosDetencion,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.eventosDetencion.value"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.esAcumulable && _vm.showTemporalidad
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          rules: {
                                            required:
                                              _vm.muestraAlertaDetencionNoAutorizada &&
                                              !_vm.deshabilitaParametrosGenerales
                                                ? true
                                                : false,
                                            numeric: true,
                                            max: 3,
                                            min_value:
                                              _vm.muestraAlertaDetencionNoAutorizada &&
                                              _vm.formFields.eventos.value < 1
                                                ? 1
                                                : 0,
                                            integer: true,
                                            temporalidad_mayor: true
                                          }
                                        },
                                        expression:
                                          "{\n                  rules: {\n                    required:\n                      muestraAlertaDetencionNoAutorizada &&\n                      !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 3,\n                    min_value:\n                      muestraAlertaDetencionNoAutorizada &&\n                      formFields.eventos.value < 1\n                        ? 1\n                        : 0,\n                    integer: true,\n                    temporalidad_mayor: true,\n                  },\n                }"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.formFields.temporalidad.label,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.temporalidad.id
                                      ),
                                      "data-vv-name":
                                        _vm.formFields.temporalidad.id,
                                      disabled:
                                        _vm.modoVer ||
                                        _vm.deshabilitaParametrosGenerales,
                                      counter: "3"
                                    },
                                    on: {
                                      change: _vm.handleTemporalidadChange,
                                      keypress: function($event) {
                                        return _vm.handleFilterInputNumber(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.formFields.temporalidad.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.temporalidad,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.temporalidad.value"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.muestraAlertaDetencionNoAutorizada &&
                                          !_vm.deshabilitaParametrosGenerales
                                            ? true
                                            : false,
                                        numeric: true,
                                        max: 3,
                                        min_value: 1,
                                        integer: true,
                                        temporalidad_mayor:
                                          _vm.deshabilitaDetencionVelocidad ===
                                          true
                                            ? false
                                            : true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      muestraAlertaDetencionNoAutorizada &&\n                      !deshabilitaParametrosGenerales\n                        ? true\n                        : false,\n                    numeric: true,\n                    max: 3,\n                    min_value: 1,\n                    integer: true,\n                    temporalidad_mayor:\n                      deshabilitaDetencionVelocidad === true ? false : true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tiempoDetencion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tiempoDetencion.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.tiempoDetencion.id,
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.deshabilitaParametrosGenerales,
                                  counter: "3"
                                },
                                on: {
                                  change: _vm.handleTiempoDetencionChange,
                                  keypress: function($event) {
                                    return _vm.handleFilterInputNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.tiempoDetencion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tiempoDetencion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tiempoDetencion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-flex", {
                            attrs: { xs12: "", sm6: "", md6: "" }
                          }),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: _vm.formFields.tipoZona.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tipoZona.id
                                  ),
                                  "data-vv-name": _vm.formFields.tipoZona.id,
                                  items: _vm.lstTipoZonas,
                                  "item-text": "nombre",
                                  "item-value": "id"
                                },
                                on: { change: _vm.handleTipoZonaChange },
                                model: {
                                  value: _vm.formFields.tipoZona.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tipoZona,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tipoZona.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("Buscador", {
                                attrs: {
                                  filter:
                                    _vm.gridApiZonasDetencion &&
                                    _vm.gridApiZonasDetencion.setQuickFilter.bind(
                                      _vm.gridApiZonasDetencion
                                    )
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-container",
                            {
                              attrs: {
                                "grid-list-md": "",
                                "text-xs-center": ""
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md12: "" } },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _vm.modoVer
                                            ? _c("MantenedorGridVerDetalle", {
                                                attrs: {
                                                  "grid-options":
                                                    _vm.gridOptionsZonasDetencion,
                                                  "row-data":
                                                    _vm.lstZonasVerDetalle
                                                }
                                              })
                                            : _c("AsociacionGrid", {
                                                attrs: {
                                                  "grid-options":
                                                    _vm.gridOptionsZonasDetencion,
                                                  esEditar: !_vm.alertaSeleccionada
                                                    ? false
                                                    : true
                                                }
                                              })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.muestraAlertaMantencionPorVencer,
                              expression: "muestraAlertaMantencionPorVencer"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          (_vm.muestraAlertaMantencionPorVencer
                                            ? true
                                            : false) &&
                                          _vm.formFields.kilometros.value ===
                                            "" &&
                                          _vm.formFields.tiempo.value === "",
                                        numeric: true,
                                        min_value: 1,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      (muestraAlertaMantencionPorVencer ? true : false) &&\n                      formFields.kilometros.value === '' &&\n                      formFields.tiempo.value === '',\n                    numeric: true,\n                    min_value: 1,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.horasMotor.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.horasMotor.id
                                  ),
                                  "data-vv-name": _vm.formFields.horasMotor.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.horasMotor.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horasMotor,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.horasMotor.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          (_vm.muestraAlertaMantencionPorVencer
                                            ? true
                                            : false) &&
                                          _vm.formFields.horasMotor.value ===
                                            "" &&
                                          _vm.formFields.tiempo.value === "",
                                        numeric: true,
                                        min_value: 1,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      (muestraAlertaMantencionPorVencer ? true : false) &&\n                      formFields.horasMotor.value === '' &&\n                      formFields.tiempo.value === '',\n                    numeric: true,\n                    min_value: 1,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.kilometros.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.kilometros.id
                                  ),
                                  "data-vv-name": _vm.formFields.kilometros.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.kilometros.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.kilometros,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.kilometros.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          (_vm.muestraAlertaMantencionPorVencer
                                            ? true
                                            : false) &&
                                          _vm.formFields.kilometros.value ===
                                            "" &&
                                          _vm.formFields.horasMotor.value ===
                                            "",
                                        numeric: true,
                                        max_value: _vm.maximoTiempo,
                                        min_value: 1,
                                        integer: true
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required:\n                      (muestraAlertaMantencionPorVencer ? true : false) &&\n                      formFields.kilometros.value === '' &&\n                      formFields.horasMotor.value === '',\n                    numeric: true,\n                    max_value: maximoTiempo,\n                    min_value: 1,\n                    integer: true,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tiempo.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tiempo.id
                                  ),
                                  "data-vv-name": _vm.formFields.tiempo.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.tiempo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tiempo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tiempo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required: _vm.muestraAlertaMantencionPorVencer
                                          ? true
                                          : false
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required: muestraAlertaMantencionPorVencer ? true : false,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.unidadTiempo.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.unidadTiempo.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.unidadTiempo.id,
                                  items: _vm.formFields.unidadTiempo.items,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  disabled: _vm.modoVer
                                },
                                on: { change: _vm.handleUnidadTiempo },
                                model: {
                                  value: _vm.formFields.unidadTiempo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.unidadTiempo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.unidadTiempo.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.muestraAlertaMantencionPorVencer ||
                                _vm.muestraAlertaMantencionVencida,
                              expression:
                                "\n              muestraAlertaMantencionPorVencer ||\n                muestraAlertaMantencionVencida\n            "
                            }
                          ],
                          attrs: { row: "", wrap: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("BuscadorOperacionCrud", {
                                attrs: {
                                  filter:
                                    _vm.gridApiPlanes &&
                                    _vm.gridApiPlanes.setQuickFilter.bind(
                                      _vm.gridApiPlanes
                                    )
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                            _c(
                              "div",
                              { attrs: { align: "left" } },
                              [
                                _vm.modoVer
                                  ? _c("MantenedorGridVerDetalle", {
                                      attrs: {
                                        "grid-options": _vm.gridOptionsPlanes,
                                        "row-data": _vm.planes
                                      }
                                    })
                                  : _c("AsociacionGrid", {
                                      attrs: {
                                        "grid-options": _vm.gridOptionsPlanes,
                                        "row-data": _vm.planes,
                                        esEditar: !_vm.alertaSeleccionada
                                          ? false
                                          : true
                                      }
                                    })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }